import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Docelowo zmien na: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`]
// po skonfigurowaniu "Expose an API" w Azure AD
export const apiScopes = {
  scopes: [`${process.env.REACT_APP_AZURE_CLIENT_ID}/.default`],
};
